'use strict';

exports.__esModule = true;

var _ContextProps = require('../types/ContextProps');

var _get = require('../utils/get');

var IDs = {
  PAGE_NAME: 'page.name',
  PAGE_URL: 'page.url',
  SITE_NAME: 'site.name',
  HOME_PAGE_TITLE: 'site.homePageTitle'
};

exports.default = {
  IDs: IDs,
  getData: function getData(item) {
    var _ref;

    return _ref = {}, _ref[IDs.PAGE_NAME] = (0, _get.get)(item, 'context.' + _ContextProps.CONTEXT_PROPS.PAGE_NAME), _ref[IDs.PAGE_URL] = (0, _get.get)(item, 'context.' + _ContextProps.CONTEXT_PROPS.DEFAULT_URL), _ref[IDs.SITE_NAME] = (0, _get.get)(item, 'context.' + _ContextProps.CONTEXT_PROPS.SITE_NAME), _ref[IDs.HOME_PAGE_TITLE] = (0, _get.get)(item, 'context.' + _ContextProps.CONTEXT_PROPS.HOME_PAGE_TITLE), _ref;
  },
  getLegacySeoBlob: function getLegacySeoBlob() {
    return { tags: [] };
  },
  getKeys: function getKeys() {
    return Object.keys(IDs).map(function (id) {
      return { id: id };
    });
  }
};